import { Card, CardHeader, CardContent } from '@mui/material'
import StoreKeyProvider from '../../providers/StoreKeyProvider'
import WithFilters from '../../hocs/WithFilters'
import DataTable from '../dataTable/DataTable'
import PropTypes from 'prop-types'
import DataInputs from '../dataTable/DataInputs'
import { useEffect, useState } from 'react'
import axios from 'axios'
import eventBus from '../../../lib/eventBus'

const parseAllExaminations = (examinations) => {
  let result = []
  const typesKeys = Object.keys(examinations)
  for (let i = 0; i < typesKeys.length; i++) {
    result = [...result, ...examinations[typesKeys[i]]]
  }
  return result
}

const PatientsPreview = ({ patientId }) => {
  const [examinations, setExaminations] = useState()
  const [allExaminations, setAllExaminations] = useState()
  const [examinationsTypes, setExaminationsTypes] = useState()
  const [chosenExaminationsType, setChosenExaminationsType] = useState()

  useEffect(() => {
    axios.post('lookups/examinations', null).then((res) => {
      setExaminations(res.data)
      setAllExaminations(parseAllExaminations(res.data))
    })
    axios.post('lookups/examination_types', null).then((res) => {
      setExaminationsTypes(res.data)
    })
  }, [])

  useEffect(() => {
    eventBus.on('newFilterValues', async (data) => {
      await setChosenExaminationsType(data.type_id)
    })

    return eventBus.remove('newFilterValues')
  }, [])

  useEffect(() => {
    eventBus.dispatch('forceFilterValue', {
      key: 'examination_id',
      value: null,
      filter: 'ExaminationsKey',
    })
  }, [chosenExaminationsType])

  return (
    <>
      <StoreKeyProvider storeKey="PatientsDataPreviewKey">
        <WithFilters
          config={{
            page: 1,
            paginate: 10,
            orderType: 'desc',
            order: 'created_at',
            inputs: {
              type_id: {
                value: '',
                relation: 'LIKE',
              },
              examination_id: {
                value: null,
                relation: 'WHERE',
              },
              min_created_at: {
                value: null,
                relation: 'MIN',
              },
              max_created_at: {
                value: null,
                relation: 'MAX',
              },
              doctor_name: {
                value: '',
                relation: 'LIKE',
              },
            },
          }}
          endpoint={`/patients/${patientId}/examinations`}
        >
          <Card elevation={2} square>
            <CardHeader title="Wyniki Badań"></CardHeader>
            <CardContent>
              {examinations && examinationsTypes && (
                <DataInputs
                  inputs={[
                    {
                      id: 'type_id',
                      label: 'Typ',
                      placeholder: '',
                      type: 'select',
                      options: examinationsTypes,
                    },
                    {
                      id: 'examination_id',
                      label: 'Badanie',
                      placeholder: '',
                      type: 'select',
                      options: chosenExaminationsType
                        ? examinations[chosenExaminationsType]
                        : allExaminations,
                    },
                    {
                      id: 'created_at',
                      label: 'Data wykonania',
                      placeholder: '',
                      type: 'date-between',
                    },
                    {
                      id: 'doctor_name',
                      label: 'Lekarz',
                      placeholder: '',
                      type: 'text',
                    },
                  ]}
                />
              )}
              <DataTable
                breakpoint={1200}
                actions="PatientsPreviewActions"
                labels={['Badanie', 'Nr. zęba', 'Data wykonania', 'Lekarz']}
                keys={[
                  'examination_name',
                  'tooth1',
                  'created_at',
                  'doctor_name',
                ]}
              />
            </CardContent>
          </Card>
        </WithFilters>
      </StoreKeyProvider>
    </>
  )
}

PatientsPreview.propTypes = {
  patientId: PropTypes.string,
}

export default PatientsPreview
